import React, { useEffect, useState } from "react";
import { } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Url } from "../config/config";
import { dateFormat } from "../utils";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import useFullPageLoader from "../hooks/useFullPageLoader";
import useDebounce from "./../hooks/useDebounce"


export default function Query() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  //const [activePage, setActivePage] = useState(1);
  const [type, setType] = useState("Pending");
  const [query, setQuery] = useState("");
  const currentActivePage = parseInt(localStorage.getItem('queryActivePage'))
  const [activePage, setActivePage] = useState(currentActivePage || 1);
  const debounceValue = useDebounce(query, 500);
  const [iState, updateState] = useState({
    list: [],
    total: 0,
    id: "",
    fullName: "",
    email: "",
    address: "",
    contactNumber: "",
    description: "",
    createdAt: "",
    //type: "Pending",
  });

  const {
    list,
    total,
    id,
    fullName,
    email,
    address,
    contactNumber,
    description,
    createdAt,
    complainId,
    // type,
  } = iState;

  //********************Handel Query Status************************* */
  const [BlockModal, setBlockModal] = useState(false);
  const handelBlockShow = (id) => {
    updateState({ ...iState, id: id });
    setBlockModal(true);
  };
  const handleBlockClose = () => {
    setBlockModal(false);
  };
  const handelUpdateStatus = async () => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/quries?queryId=${id}`,
        method: "PUT",
      });
      hideLoader();
      if (res.data.status === 200) {
        handleBlockClose();
        setViewModal(false);
        handelSearchQuery(type, activePage, "");
        toast.success("Query status has been Mark as Complete successfully");
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //*********************Handel View Details************************ */
  const [viewModal, setViewModal] = useState(false);
  const handleViewClose = () => {
    setViewModal(false);
  };
  const handelViewOpen = (data) => {
    setViewModal(true);
    updateState({
      ...iState,
      id: data._id,
      fullName: data.fullName,
      email: data.email,
      address: data.address,
      contactNumber: data.contactNumber,
      description: data.description,
      createdAt: data.createdAt,
      complainId: data.complainId
    });
  };
  const handelViewetails = async () => { };

  //*********************Handel Search Query************************ */
  const handelSearchQuery = async (type, page = 1, query) => {
    try {
      showLoader();
      console.log(type, "............", page, "///////////////", query);
      const res = await axios({
        url: `${Url}/quries?currentStatus=${type}&page=${page}&search=${query}`,
        method: "GET",
      });
      hideLoader();
      if (res.data.status === 200) {
        updateState({
          ...iState,
          list: res.data.data.qurieslisting,
          total: res.data.data.total,
        });
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //**************************Handel Category Filter**************** */
  const handelCategoryType = (e) => {
    //console.log(e.target.value);
    setType(e.target.value);
    handelSearchQuery(e.target.value, activePage, query);
  };

  //****************************Handel Search********************** */
  const handelSearch = (e) => {
    setQuery(e.target.value);
    // handelSearchQuery(type, activePage, e.target.value);
  };

  //***************************Handel Pagination Onchange********** */
  const handlePageChange = (pageNo) => {
    setActivePage(pageNo);
    handelSearchQuery(type, pageNo, query);
  };
  useEffect(() => {
    handelSearchQuery(type, activePage, debounceValue);

    localStorage.setItem("queryActivePage", activePage)
  }, [activePage, debounceValue])
  return (
    <React.Fragment>
      <title>Queries Management</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <select
                className=""
                onChange={(e) => {
                  handelCategoryType(e);
                }}
              >
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
              </select>
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />
            </div>
            <h4 className="Title">Queries Management</h4>

            <div className="TableList">
              {loader}
              <table>
                <thead>
                  <tr>
                    <th>Complain Id</th>
                    <th>User Name</th>
                    <th>Mobile Number</th>
                    <th>View</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {list &&
                    list.length > 0 &&
                    list.map((item, i) => (
                      <tr key={i}>
                        <td>{item.complainId}</td>
                        <td>{item.fullName}</td>
                        <td>{item.contactNumber}</td>
                        <td>
                          <button
                            className="view_btn"
                            onClick={(e) => {
                              handelViewOpen(item);
                            }}
                          >
                            View
                          </button>
                        </td>
                        <td>
                          {item.currentStatus === "Pending" ? (
                            <>
                              <button
                                className="mark-as"
                                onClick={(e) => {
                                  handelBlockShow(item._id);
                                }}
                              >
                                Mark as complete
                              </button>
                            </>
                          ) : (
                            <button className="completed">Completed</button>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="ModalBox">
        {/* block or unblock model */}
        <Modal show={BlockModal} onHide={handleBlockClose}>
          <Modal.Header closeButton onClick={handleBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to mark it completed?</Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handleBlockClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelUpdateStatus}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>

        {/* end block unblock modal */}

        {/* Start View Details Modal */}
        <Modal
          show={viewModal}
          className="query_manage"
          onHide={handleViewClose}
        >
          <Modal.Header closeButton onClick={handleViewClose}>
            <Modal.Title>Queries Management</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="">
              <h5>{fullName}</h5>
              <ul>
                <li>
                  <b>Complaint No :</b>  {complainId}
                </li>
                <li>
                  <b>Query raised On :</b> {dateFormat(createdAt)}
                </li>
              </ul>
              <p>{description}</p>
            </div>
            {/* 
             <div className="row">
              <div className="col-sm-6">{fullName} Complaint No :456767</div>
              <div className="col-sm-6">
                Query raised On :{dateFormat(createdAt)}
              </div>
            </div>
            <br></br>
            <br></br>
            <div className="row">{description}</div>  */}
          </Modal.Body>
          <Modal.Footer>
            <button variant="secondary" onClick={handelUpdateStatus}>
              Mark As Closed
            </button>
          </Modal.Footer>
        </Modal>
        {/* End view Modal */}
      </div>
    </React.Fragment>
  );
}
